import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { api, type Ben } from './api';
import { kullaniciDegisti } from './kullanici-degisti';

interface OturumDurumu {
  ben: Ben | null;
  yukleniyor: boolean;
  yenile: () => Promise<void>;
  cikis: () => Promise<void>;
}

const Ctx = createContext<OturumDurumu | null>(null);

export function OturumSaglayici({ children }: { children: ReactNode }) {
  const [ben, setBen] = useState<Ben | null>(null);
  const [yukleniyor, setYukleniyor] = useState(true);

  const yenile = useCallback(async () => {
    try {
      setBen(await api.get<Ben>('/auth/ben'));
    } catch {
      setBen(null);
    } finally {
      setYukleniyor(false);
    }
  }, []);

  const cikis = useCallback(async () => {
    await api.post('/auth/cikis').catch(() => undefined);
    /*
     * ⚠️ İSTEMCİDE ÖNCEKİ KULLANICIDAN KALAN HER ŞEY SİLİNİR — service worker
     *    önbellekleri (API + fotoğraf) ve ekran ayarları. Gerekçe tek yerde:
     *    `lib/kullanici-degisti.ts`. Aynı temizlik kullanıcı geçişinde de
     *    çağrılıyor; ikisi ayrı yazılmasın diye ortak fonksiyon.
     */
    await kullaniciDegisti();
    setBen(null);
  }, []);

  useEffect(() => {
    void yenile();
  }, [yenile]);

  return <Ctx.Provider value={{ ben, yukleniyor, yenile, cikis }}>{children}</Ctx.Provider>;
}

export function useOturum(): OturumDurumu {
  const c = useContext(Ctx);
  if (!c) throw new Error('useOturum, OturumSaglayici içinde kullanılmalı');
  return c;
}
